import { SelectOption } from "@models/ui-models/select-options";

export enum PayslipReason {
  ExistingDebt,
  ChangeOfNameConfirmed,
  NameReservationConfirmed,
  LateFeeUnder28Days,
  LateFeeOver28Days,
  CompanyDeregistration,
  AnnualFeeForSpecialPurposeCompany,
  AnnualFeeForStandardCompany,
  AnnualFeeForProprietaryNonProfitCompany,
  AnnualFeeForListedPublicCompany,
  AnnualFeeForUnlistedPublicCompany,
  AnnualFeeForUnlistedPublicNonProfitCompany,
  Other,
}

export const PayslipReasonLabels: Record<PayslipReason, string> = {
  [PayslipReason.ExistingDebt]: 'Existing Debt',
  [PayslipReason.ChangeOfNameConfirmed]: 'Change of Name confirmed',
  [PayslipReason.NameReservationConfirmed]: 'Name Reservation confirmed',
  [PayslipReason.LateFeeUnder28Days]: 'Late fee (under 28 days)',
  [PayslipReason.LateFeeOver28Days]: 'Late fee (over 28 days)',
  [PayslipReason.CompanyDeregistration]: 'Company Deregistration',
  [PayslipReason.AnnualFeeForSpecialPurposeCompany]: 'Annual Fee for Special Purpose Company',
  [PayslipReason.AnnualFeeForStandardCompany]: 'Annual Fee for Standard Company',
  [PayslipReason.AnnualFeeForProprietaryNonProfitCompany]: 'Annual Fee for Proprietary Non-Profit Company',
  [PayslipReason.AnnualFeeForListedPublicCompany]: 'Annual Fee for Listed Public Company',
  [PayslipReason.AnnualFeeForUnlistedPublicCompany]: 'Annual Fee for Unlisted Public Company',
  [PayslipReason.AnnualFeeForUnlistedPublicNonProfitCompany]: 'Annual Fee for Unlisted Public Non-Profit Company',
  [PayslipReason.Other]: 'Other',
};

export const PayslipReasonPaidAmount: Record<PayslipReason, string> = {
  [PayslipReason.ExistingDebt]: '',
  [PayslipReason.ChangeOfNameConfirmed]: '503',
  [PayslipReason.NameReservationConfirmed]: '62',
  [PayslipReason.LateFeeUnder28Days]: '98',
  [PayslipReason.LateFeeOver28Days]: '411',
  [PayslipReason.CompanyDeregistration]: '50',
  [PayslipReason.AnnualFeeForSpecialPurposeCompany]: '67',
  [PayslipReason.AnnualFeeForStandardCompany]: '329',
  [PayslipReason.AnnualFeeForProprietaryNonProfitCompany]: '62',
  [PayslipReason.AnnualFeeForListedPublicCompany]: '1528',
  [PayslipReason.AnnualFeeForUnlistedPublicCompany]: '62',
  [PayslipReason.AnnualFeeForUnlistedPublicNonProfitCompany]: '1528',
  [PayslipReason.Other]: '',
};

export const payslipReasonOptions: SelectOption<string>[] = Object.values(PayslipReason)
  .filter((reason) => reason == +reason)
  .map((reason) => {
    return {
      label: PayslipReasonLabels[reason],
      value: PayslipReasonPaidAmount[reason],
    };
  });
